/**
 * Sleep for a specified number of milliseconds.
 *
 * @param {number} ms - The number of milliseconds to sleep for. Defaults to 2000.
 * @return {Promise<void>} A Promise that resolves after the specified number of milliseconds.
 */
export const sleep = (ms = 2000) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const debounce = (func, wait) => {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};
